import React from 'react';
import cx from 'classnames';
import { ArrowDown, ArrowUp } from '@mediahuis/chameleon-theme-wl/icons';
import Box from '../../Box';
import Text from '../../Text';
import Icon from '../../Icon';
import styles from './index.module.scss';

var Th = function Th(_ref) {
  var _cx;

  var children = _ref.children,
      ellipsis = _ref.ellipsis,
      className = _ref.className,
      colSpan = _ref.colSpan,
      width = _ref.width,
      textAlign = _ref.textAlign,
      onKeyDown = _ref.onKeyDown,
      onClick = _ref.onClick,
      sortDirection = _ref.sortDirection,
      sortable = _ref.sortable;
  return /*#__PURE__*/React.createElement(Box, {
    as: "th",
    color: "grey60",
    px: 6,
    py: 4,
    textAlign: textAlign,
    colSpan: colSpan,
    width: width,
    className: cx((_cx = {}, _cx[styles.root] = true, _cx[styles.ellipsis] = ellipsis, _cx), className),
    scope: "col",
    "aria-sort": sortDirection
  }, /*#__PURE__*/React.createElement(Text, {
    className: cx(styles.root, sortable && styles.sortable),
    size: "Caption2",
    fontFamily: "system",
    fontWeight: "medium",
    color: "grey60",
    textTransform: "uppercase",
    role: sortable ? 'button' : null,
    tabIndex: sortable ? '0' : null,
    onClick: onClick,
    onKeyDown: onKeyDown
  }, children, sortable && /*#__PURE__*/React.createElement(Icon, {
    className: cx(styles.sortIcon, sortDirection && styles.sortIconActive),
    as: sortDirection === 'ascending' ? ArrowDown : ArrowUp,
    size: "small",
    color: "greyBase"
  })));
};

export default Th;